(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9477],{

/***/ 68837:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/card-check.f4cdaa52.svg","height":26,"width":26});

/***/ }),

/***/ 95160:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial.ced62c92.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEURFBd8gYaUmqKGjpU8PkLI0NdeYGMsIyK9x84fHiDP197Y4OaxusJscnqOl6GEV0pzd3y1v8dNNSpmanDm7vUyPUmDeXqtpac+MyxIUltWR0V+X1yrf3NZlvnUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQUlEQVR4nAXBBwLAIAgEsFNAwNm9///OJkiJAfiCEKbEDkeMFFZVYLZKrBdgktt+P4pctsPbNyBSTuV3wEwq9R5/SKUCZJmYbxoAAAAASUVORK5CYII="});

/***/ }),

/***/ 30223:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial1.0f60859c.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAe1BMVEXEqI7urWR2fYDQs5R1gonfmEvYkELLwK2dq6TP0sN2bWuGe3W9s6CFaFd9dXK0qJdibW2LmJl+jZJSUVM0OENrcneatLDqpVKbqKKVoaLkrnSafWqlnZByVVDYqX9POTmXin08LTKfi4GXeGuKXFZ6Yl5TXWIWGCNjd312rNSUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASUlEQVR4nAXBhwKAEAAFwFcIIbO9d///hd3heQOtpRDIkw9Udg3u5HxezhpfdP14XCviQpTl1Q6TDdZu1YmizQjXU4mCMXAY9QOjpwQdeydA3AAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 40358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial2.cb003145.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEU2QEl8hpDd4+l/kJcYHyPN3+yqwtIBCQ+fsb4pMDVjf49NW2VcYWhgbHiKeneQmJ6blZZ9aGYaJjNvi5AwNz6KoLCMorJjWl7Exc2ns766rrBLUVpRUFaam6MPGSOqs7d0bnCtxMJINjJLZm+yx8GXcGqhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBgwHAQAAEsHvbtbX/jE3Q7vRwoEP7cjGOGFjmI8cy4q315CpPMMppdWgJj3CpVUjYUOI2iwGMpJ1S3f+CxAN8evNNvAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 22365:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial3.ad474258.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEW/2NXU4ddHV1lqc3u50tORiJHAxsLJ4dqKhIezwseTqq1adH+VoqpSbHJ6kZqswcGdr61xh481T1jG2dWzsrGjrLC5z8p6eHalm5ZLaWyKjpKZgYSVm56wmpzwgMuiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBBQKAMAwEsBuTtnPF+f83SaC9IUIRBLMDBhFbjuLcfMGHvh9eCvZUahB9sFx9dZNhUwutDMF2pd6zrB9aSwLbWoXnHwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 63997:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial4.d3f782e2.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAdVBMVEUbKzqpm5CbeG2MiIXKrpUnOEdNUVXY3tve6uk3OkHa4+JESEzA1tSsyNBafo2z0t2rsayjsrfK0tJxXlrDrZawrqXT2dPY2tLQzsHK4OL18eyjytefz954h42IfXFKbHui0uB7scF9aVpVaXRoZWYtLTSyqqHBFHIbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVR4nAXBhQGAMAADsM6NGcPd/z+RBG2jtKrTB8a7UbNiQHmv1UNfSDJM9i4GwqTKzjlDYK1qHyOEgyP+WIDtkmfYww+B2QPBoyIzwQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 42848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/koalafi-logo-1.1566232e.png","height":460,"width":443,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEX///+wwMzE09zU5OjK2N73+fq/5PFCbGPLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nGNgwAOYWZiZWZhYGRjYmBgZGUEMnAAABjYAK6aIYWcAAAAASUVORK5CYII="});

/***/ }),

/***/ 18391:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/momnt-logo-1.574fcdc8.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEX////9/v7Hz9iotMLT2N/Xyczt2NeZqLm3ws+2vcr3gVs8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nGWKuREAIBCE2L1H7b9hIzWQjAE4SEjSdfDoigiTs8vL+dI3bwvrAFSrPaUWAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 15968:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz-color.ffbab323.svg","height":31,"width":96});

/***/ }),

/***/ 33911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96});

/***/ }),

/***/ 8869:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Clearco.46288e58.svg","height":25,"width":119});

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers-color.36dfc671.svg","height":44,"width":82});

/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82});

/***/ }),

/***/ 68197:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Openly.36908f71.svg","height":45,"width":71});

/***/ }),

/***/ 18378:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered-color.d788f387.svg","height":45,"width":111});

/***/ }),

/***/ 86051:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111});

/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ }),

/***/ 10974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Highlights; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 14 modules
var format = __webpack_require__(4758);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/utils/butter-client.js
var butter_client = __webpack_require__(55894);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/icons/Open.svg
/* harmony default export */ var Open = ({"src":"/_next/static/media/Open.3c28fb28.svg","height":12,"width":12});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/Highlights.jsx






var Highlights = function() {
    var ref = (0,react.useState)([]), highlights = ref[0], setHighlights = ref[1];
    (0,react.useEffect)(function() {
        butter_client/* default.post.list */.Z.post.list({
            page: 1,
            page_size: 3
        }).then(function(response) {
            var data = response.data.data;
            setHighlights(data);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "home_highlights-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "home_highlights",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Recent highlights from our blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "home_highlights-grid",
                        children: highlights.map(function(param) {
                            var featured_image = param.featured_image, title = param.title, summary = param.summary, author = param.author, published = param.published, slug = param.slug;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/blog/".concat(slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "img-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: featured_image,
                                                alt: "",
                                                layout: "fill",
                                                unoptimized: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "home_highlights-card_text",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "open-icon",
                                                    src: Open.src,
                                                    alt: "Open",
                                                    loading: "eager",
                                                    width: "10",
                                                    height: "10"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: summary
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "author",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "avatar",
                                                    src: author.profile_image,
                                                    alt: "",
                                                    title: "".concat(author.first_name, " ").concat(author.last_name),
                                                    loading: "lazy",
                                                    width: "40",
                                                    height: "40"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                author.first_name,
                                                                " ",
                                                                author.last_name
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: (0,format/* default */.Z)(new Date(published), "LLLL dd, yyyy")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, title);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 97281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Testimonial_Testimonial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/views/components/sections/Testimonial.module.less
var Testimonial_module = __webpack_require__(74226);
var Testimonial_module_default = /*#__PURE__*/__webpack_require__.n(Testimonial_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/icons/prevArrow.svg
/* harmony default export */ var prevArrow = ({"src":"/_next/static/media/prevArrow.fa633cbd.svg","height":56,"width":56});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/icons/nextArrow.svg
/* harmony default export */ var nextArrow = ({"src":"/_next/static/media/nextArrow.7c63c4fa.svg","height":56,"width":56});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/icons/nextArrow2.svg
/* harmony default export */ var nextArrow2 = ({"src":"/_next/static/media/nextArrow2.d5950f62.svg","height":56,"width":56});
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial.png
var Testimonial = __webpack_require__(95160);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial1.png
var Testimonial1 = __webpack_require__(30223);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial2.png
var Testimonial2 = __webpack_require__(40358);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial3.png
var Testimonial3 = __webpack_require__(22365);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial4.png
var Testimonial4 = __webpack_require__(63997);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/momnt-logo-1.png
var momnt_logo_1 = __webpack_require__(18391);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/koalafi-logo-1.png
var koalafi_logo_1 = __webpack_require__(42848);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Clearco-color.svg
/* harmony default export */ var Clearco_color = ({"src":"/_next/static/media/Clearco-color.16a50c3e.svg","height":25,"width":119});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Openly-color.svg
/* harmony default export */ var Openly_color = ({"src":"/_next/static/media/Openly-color.e1bd3ce8.svg","height":45,"width":71});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers-color.svg
var Farmers_color = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered-color.svg
var StandardChartered_color = __webpack_require__(18378);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz-color.svg
var Anz_color = __webpack_require__(15968);
// EXTERNAL MODULE: ./src/landingPage/views/components/LinkButton.jsx
var LinkButton = __webpack_require__(84135);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/Testimonial.jsx





















var testimonials = [
    {
        quote: "We wouldn't have been as good at what we are doing had we not had a partner like Demyst that can flip on data, data partners and data channels effectively overnight, and advise us on the other data channels and data partners we should be looking at for our benefit. Time to market with a partner like Demyst was and is crucial for our success, especially our early success.",
        role: "Chief Technology Officer",
        source: "Brian Lanehart",
        color: "gray",
        image: momnt_logo_1/* default */.Z
    },
    {
        quote: "Leveraging a single API to maintain external data relationships has simplified and accelerated our fraud prevention and credit processes supporting business growth into new geographies.",
        role: "Director of Engineering",
        source: "Leading Global Payments and Shopping Service",
        color: "aqua",
        image: Testimonial/* default */.Z
    },
    {
        quote: "There's a lot of simplicity to doing a one-time integration versus a bunch of independent integrations.",
        role: "Senior Vice President of Fraud",
        source: "David Hicks",
        color: "blue",
        image: koalafi_logo_1/* default */.Z
    },
    {
        quote: "Given the complexity and the number of teams involved and integrations this implementation has gone extremely well, which is a testament to the testing planning and preparation.",
        role: "Senior Program Manager",
        source: "Tier 1 Australian Bank",
        color: "blue",
        image: Testimonial2/* default */.Z
    },
    {
        quote: "As a startup, there's no way we could've gotten to market with a beta product in six months, without someone like Demyst.",
        role: "Chief Technology Officer",
        source: "Brian Lanehart",
        color: "gray",
        image: momnt_logo_1/* default */.Z
    },
    {
        quote: "You’ve exceeded my expectations.",
        role: "Head of Risk",
        source: "Leading Asia Pacific cashback platform",
        color: "purple",
        image: Testimonial3/* default */.Z
    },
    {
        quote: "It's also important in a partner like Demyst because they know the industry because they understand your business and your use case, so they can coach you through making sure you're always making good, healthy decisions on how you're using the data.",
        role: "Senior Vice President of Fraud",
        source: "David Hicks",
        color: "blue",
        image: koalafi_logo_1/* default */.Z
    },
    {
        quote: "This sophisticated new technology is deeply integrated with client's existing platforms to provide our customers with a quick, simple and secure lending experience so they can spend more time running and growing their business.",
        role: "Group Executive",
        source: "Tier 1 Australian Bank",
        color: "gray",
        image: Testimonial4/* default */.Z
    },
    {
        quote: "Thank you for a great year and getting our project live. Appreciate your patience, hard work as well as resilience in getting us to a very good position ahead of our pilot activation.",
        role: "Senior Delivery Manager",
        source: "Tier 1 Australian Bank",
        color: "red",
        image: Testimonial1/* default */.Z
    }, 
];
var getNextIndex = function(currentIndex) {
    var index = currentIndex + 1;
    return index < testimonials.length ? index : 0;
};
var getPrevIndex = function(currentIndex) {
    var index = currentIndex - 1;
    return index >= 0 ? index : testimonials.length - 1;
};
var Testimonial_Testimonial = function(param) {
    var withCustomers = param.withCustomers, _variant = param.variant, variant = _variant === void 0 ? "A" : _variant;
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    var _index = testimonials[index], quote = _index.quote, role = _index.role, source = _index.source, color = _index.color, image = _index.image;
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            setIndex(getNextIndex(index));
        }, 10000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: variant === "B" ? (Testimonial_module_default()).backgroundB : (Testimonial_module_default()).background,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Testimonial_module_default()).home_testimonials,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "What industry leaders are saying about Demyst"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((Testimonial_module_default()).testimonial, " ").concat((Testimonial_module_default())[color]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (Testimonial_module_default()).quote,
                                        children: [
                                            "“",
                                            quote,
                                            "”"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (Testimonial_module_default()).role,
                                        children: [
                                            "— ",
                                            role
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Testimonial_module_default()).source,
                                        children: source
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Testimonial_module_default()).arrows,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return setIndex(getPrevIndex(index));
                                                },
                                                title: "Go to previous testimonial",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: prevArrow.src,
                                                    alt: "Arrow left"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return setIndex(getNextIndex(index));
                                                },
                                                title: "Go to next testimonial",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: ![
                                                        "purple",
                                                        "blue"
                                                    ].includes(color) ? nextArrow.src : nextArrow2.src,
                                                    alt: "Arrow right"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Testimonial_module_default())["image-container"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image,
                                    alt: "Testimonial",
                                    layout: "fill"
                                })
                            })
                        ]
                    }),
                    withCustomers && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Testimonial_module_default()).costumers,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Join the customers already unlocking the power of external data with Demyst"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Testimonial_module_default()).costumer_logos,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Farmers_color/* default */.Z,
                                        alt: "Farmers Insurance",
                                        loading: "eager",
                                        width: "82",
                                        height: "44"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Anz_color/* default */.Z,
                                        alt: "ANZ",
                                        loading: "eager",
                                        width: "96",
                                        height: "31"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: StandardChartered_color/* default */.Z,
                                        alt: "Standard Chartered",
                                        loading: "eager",
                                        width: "111",
                                        height: "100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Openly_color,
                                        alt: "Openly",
                                        loading: "eager",
                                        width: "71",
                                        height: "45"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Clearco_color,
                                        alt: "Clearco (formerly Clearbank)",
                                        loading: "eager",
                                        width: "119",
                                        height: "100"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        className: (Testimonial_module_default()).cta,
                        autoWidth: true,
                        variant: "primary",
                        href: linksConstants/* linksConstants.RESOURCES */.s.RESOURCES,
                        children: "Read Customer Stories"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 74226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"Testimonial_background__oT9Oy","section-layout":"Testimonial_section-layout__LwQVT","backgroundB":"Testimonial_backgroundB__8fzTw","costumers":"Testimonial_costumers__E6wbQ","costumer_logos":"Testimonial_costumer_logos__W4EKN","home_testimonials":"Testimonial_home_testimonials__YF9Ny","testimonial":"Testimonial_testimonial__k98XC","image-container":"Testimonial_image-container__fpEuQ","quote":"Testimonial_quote__QmZ_n","role":"Testimonial_role__H3fdn","source":"Testimonial_source__4qhk3","arrows":"Testimonial_arrows__diuFA","aqua":"Testimonial_aqua__NSwLS","purple":"Testimonial_purple__b1Iwn","blue":"Testimonial_blue__rR4nq","gray":"Testimonial_gray___R9TL","red":"Testimonial_red__GJkty","cta":"Testimonial_cta__zUOQE"};

/***/ })

}]);